<ng-container *ngIf="typeView === enumTypeView.ISF; else typeCompany">
  <address-view-isf
    [formGroup]="formGroup"
    [code]="code"
    [errors]="errors"
    [isShowState]="isShowState"
    [isShowCountry]="isShowCountry"
    [isFilterRestrictedCountries]="isFilterRestrictedCountries"
    [isDesktop]="isDesktop"
    [defaultCountry]="defaultCountry"
  ></address-view-isf>
</ng-container>
<ng-template #typeCompany>
  <address-view-company
    [formGroup]="formGroup"
    [code]="code"
    [errors]="errors"
    [isShowState]="isShowState"
    [isAllowCountryDisable]="isAllowCountryDisable"
    [isShowErrors]="isShowErrors"
    [isFilterRestrictedCountries]="isFilterRestrictedCountries"
    [isForeignCompany]="isForeignCompany"
    [defaultCountry]="defaultCountry"
    [isShowRequired]="isShowRequired"
  ></address-view-company>
</ng-template>
